module.exports = __webpack_public_path__ + "static/media/20ECE22.a9dc42cf.jpg";